import { PlatformEnums } from 'utils/platforms';

/**
 * Which action buttons the users toolbar shows for the table being viewed.
 *
 * Add User and CSV Create create 8x8 users, and Builder builds Microsoft Teams
 * call flows, so each belongs only to that platform's own users table — never
 * to the table listing users across all platforms (2939).
 *
 * Lives here, rather than on UsersButtons, so the page's toolbar-overflow
 * measurement counts exactly the buttons that render instead of mirroring
 * these conditions separately.
 *
 * @param {object} args
 * @param {{ id: string } | undefined} args.selectedPlatform - the platform
 *   whose users table is on screen; undefined for the all-platforms table.
 * @param {boolean} args.isReAccountsPath - whether the users route is active.
 */
export const getUsersButtonVisibility = ({
    selectedPlatform,
    isReAccountsPath,
}) => {
    const isEightByEightTable =
        selectedPlatform?.id === PlatformEnums.EIGHTBYEIGHT;
    const isMicrosoftTeamsTable = selectedPlatform?.id === PlatformEnums.TEAMS;

    return {
        addUser: isEightByEightTable,
        csvUpdate: true,
        csvCreate: isEightByEightTable,
        syncUsers: true,
        builder: Boolean(isReAccountsPath) && isMicrosoftTeamsTable,
    };
};
